export default "__VITE_ASSET__BAcZG8cT__"